const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  userInfo: (state) => state.user.userInfo,
  dict: (state) => state.dict,
  menuRouteList: (state) => state.user.menuRouteList,
  advertiserId: (state) => state.create.advertiserId,
  ttUserId: (state) => state.create.ttUserId,
  applyLoading: (state) => state.modelDesign.applyLoading,
  getDynamicDataRes: (state) => state.modelDesign.dynamicDataRes,
  getComponentCurrentOptionsSetUp (state)  {
    const index  = state.modelDesign.currentTempIndex
    return state.modelDesign.componentOptions[index]
  },
  getCurrentComponentCache (state)  {
    const index  = state.modelDesign.currentTempIndex
    return state.modelDesign.cacheComponent[index]
  },
  // getModifiedTableHeaderData: (state) => state.modelDesign.modifiedTableHeaderData,
  getModifiedTableHeaderData: (state) => {
    const index  = state.modelDesign.currentTempIndex
    return state.modelDesign.modifiedTableHeaderData[index]
  },
  getCurrentTablePosition: (state) => state.modelDesign.currentTablePosition,
  getCurrentTempIndex: (state) => state.modelDesign.currentTempIndex,
  viewLoading: (state) => state.modelDesign.viewLoading,
};
export default getters;
